export default (parent, child) => {
  return parent.children.find((e) => e.name === child);
};
